import { TableContentData } from '../../../../common/table/TableTypes';
import {
    isCellValueInDraftFormat,
    parseCellContentString,
} from '../../../../common/table/utils/tableCellContentStringUtils';
import rawGetText from '../../../../common/utils/editor/rawUtils/rawGetText';

export const EMPTY_TABLE_CONTENT_DATA: TableContentData = [[]];

/**
 * Converts table content data from version 1 to version 2 by parsing Draft.JS content strings
 * into their corresponding Draft.JS objects and extracting the raw text.
 */
export const convertTableContentDataToVersion2 = (
    tableContentData: TableContentData | null | undefined,
): TableContentData => {
    if (!tableContentData) return EMPTY_TABLE_CONTENT_DATA;

    return tableContentData.map((row) =>
        row.map((cellData) => {
            if (!cellData.value || !isCellValueInDraftFormat(cellData.value)) return cellData;

            const draftContent = parseCellContentString(cellData.value);
            if (typeof draftContent === 'string' || typeof draftContent === 'number') return cellData;

            return { ...cellData, draftContent, value: rawGetText(draftContent) };
        }),
    );
};
